import * as moment from 'moment';
import { Player } from './player.model';

export class RinknetPlayerInformation {
    constructor(json?: any) {
        this.id = json && json.id || null;        
        this.playerRNID = json && json.player_rnid || null;
        this.firstName = json && json.player_first_name || null;
        this.lastName = json && json.player_last_name || null;
        this.phoneticName = json && json.player_phonetic_name || null;
        this.appUserID = json && json.app_user_id || null;
        this.isInPortal = json && json.is_in_portal || false;
        this.isPendingInvite = json && json.is_pending_invite || false;
        this.teamRNID = json && json.team_rnid || null;
        this.teamJerseyNumber = json && json.team_jersey_number || null;
        this.positionID = json && json.player_position_id || null;
        this.positionName = json && json.player_position || null;
        this.positionShortName = json && json.player_position_short || null;
        this.homeTown = json && json.player_home_town || null;
        this.birthPlace = json && json.player_birth_place || null;
        this.shot = json && json.player_shot || null;
        this.catches = json && json.player_catches || null;
        this.nationalityID = json && json.player_nationality_id || null;
        this.schoolID = json && json.school_id || null;
        this.collegeYearID = json && json.college_year_id || null;
        this.collegeCommitmentID = json && json.college_commitment_id || null;
        this.collegeCommitmentYearID = json && json.college_commitment_year_id || null;
        // Verbal commitment defaults to true if not specified
        this.collegeCommitmentIsVerbal = (json && json.college_commitment_verbal != null) ? json.college_commitment_verbal : true;
        this.grade = json && json.player_grade || null;
        this.gpa = json && json.player_gpa || null;
        this.sat = json && json.player_sat || null;
        this.act = json && json.player_act || null;
        this.email = json && json.player_email || null;
        this.cellphone = json && json.player_cell_phone || null;
        this.birthdateNotConfirmed = json && json.player_birth_date_not_confirmed || false;
        this.agentID = json && json.agent_id || null;
        this.agentFirstName = json && json.agent_first_name || null;
        this.agentLastName = json && json.agent_last_name || null;
        this.streetAddress = json && json.player_summer_street_address || null;
        this.city = json && json.player_summer_city || null;
        this.provinceID = json && json.player_summer_province_id || null;
        this.countryID = json && json.player_summer_country_id || null;
        this.postalCode = json && json.player_summer_postal_code || null;
        this.addressPhone = json && json.player_summer_phone || null;
        this.futureTeamRNID = json && json.future_team_rnid || null;
        this.futureTeamYearRNID = json && json.future_team_year_rnid || null;
        this.pendingRosterChangeID = json && json.pending_roster_change_id || null;

        if(json && json.player_birth_date) {
            this.birthdate = moment.utc(json.player_birth_date);
        }

        if(json && json.high_school_graduation_date) {
            this.highSchoolGradDate = moment.utc(json.high_school_graduation_date);
        }

        //Convert "6.03.25" into 6'3.25" then into 75.25 inches
        if (json && json.player_height) {
            let feet = parseInt(json.player_height.substring(0,json.player_height.indexOf(".")));
            let inches = parseInt(json.player_height.substring(json.player_height.indexOf(".")+1));
            this.height = feet * 12 + inches;
        } else {
            this.height = 48;
        }

        if (json && json.player_weight && !isNaN(parseInt(json.player_weight))) {
            this.weight = parseInt(json.player_weight);
        } else {
            this.weight = 0;
        }

        if(this.gpa) {
            this.gpa = Number(this.gpa.toPrecision(4));
        }
    }

    id: number;
    playerRNID: number;
    firstName: string;
    lastName: string;
    phoneticName: string;
    appUserID: number | null;
    isInPortal: boolean;
    isPendingInvite: boolean;
    teamRNID: number;
    teamJerseyNumber: number;
    positionID: number;
    positionName: string;
    positionShortName: string;
    homeTown: string;
    birthPlace: string;
    shot: string | null;
    catches: string | null;
    nationalityID: number | null;
    height: number;
    weight: number;
    schoolID: number | null;
    collegeYearID: number | null;
    collegeCommitmentID: number | null;
    collegeCommitmentYearID: number | null;
    collegeCommitmentIsVerbal: boolean;
    highSchoolGradDate: moment.Moment | null;
    grade: number | null;
    gpa: number | null;
    sat: number | null;
    act: number | null;
    email: string;
    cellphone: string;
    agentID: number | null;
    agentFirstName: string | null;
    agentLastName: string | null;
    futureTeamRNID: number | null;
    futureTeamYearRNID: number | null;
    pendingRosterChangeID: number | null;

    streetAddress: string | null;
    city: string | null;
    provinceID: number | null;
    countryID: number | null;
    postalCode: string | null;
    addressPhone: string | null;

    birthdate: moment.Moment;
    birthdateNotConfirmed: boolean;

    toPlayer() : Player {
        let player = new Player();
        player.id = this.id;
        player.rnid = this.id;
        player.firstName = this.firstName;
        player.lastName = this.lastName;
        player.primaryTeamID = this.teamRNID;
        player.primaryTeamRNID = this.teamRNID;
        player.jerseyNumber = this.teamJerseyNumber;
        player.positionID = this.positionID;
        player.position = this.positionName;
        player.positionShort = this.positionShortName;
        player.cellPhone = this.cellphone;
        return player;
    }

    toJSON() {
        let feet = this.height != null ? Math.floor(this.height / 12) : null;
        let inches = this.height != null ? (this.height % 12) : null;
        return {
            id: this.id,
            player_rnid: this.playerRNID,
            player_first_name: this.firstName,
            player_last_name: this.lastName,
            player_phonetic_name: this.phoneticName,
            app_user_id: this.appUserID,
            team_rnid: this.teamRNID,
            team_jersey_number: this.teamJerseyNumber,
            player_position_id: this.positionID,
            player_home_town: this.homeTown,
            player_birth_place: this.birthPlace,
            player_shot: this.shot,
            player_catches: this.catches,
            player_height: (feet != null && inches != null) ? `${feet}.${('0' + inches).slice(-2)}` : null,
            player_weight: this.weight ? this.weight.toString() : null,
            player_nationality_id: this.nationalityID,
            player_birth_date: this.birthdate ? this.birthdate.format("YYYY-MM-DD") : null,

            school_id: this.schoolID,
            college_year_id: this.collegeYearID,
            college_commitment_id: this.collegeCommitmentID,
            college_commitment_year_id: this.collegeCommitmentYearID,
            college_commitment_verbal: this.collegeCommitmentIsVerbal,
            player_grade: this.grade,
            player_gpa: this.gpa,
            player_sat: this.sat,
            player_act: this.act,
            high_school_graduation_date: this.highSchoolGradDate ? this.highSchoolGradDate.format("YYYY-MM-DD") : null,

            player_summer_street_address: this.streetAddress,
            player_summer_city: this.city,
            player_summer_province_id: this.provinceID,
            player_summer_country_id: this.countryID,
            player_summer_postal_code: this.postalCode,
            player_summer_phone: this.addressPhone,
            player_email: this.email,
            player_cell_phone: this.cellphone,
            agent_id: this.agentID,
            agent_first_name: this.agentFirstName,
            agent_last_name: this.agentLastName,

            future_team_rnid: this.futureTeamRNID,
            future_team_year_rnid: this.futureTeamYearRNID
        };
    }

    copy() : RinknetPlayerInformation {
        let p = new RinknetPlayerInformation();

        p.id = this.id;
        p.firstName = this.firstName;
        p.lastName = this.lastName;
        p.phoneticName = this.phoneticName;
        p.appUserID = this.appUserID;
        p.isInPortal = this.isInPortal;
        p.isPendingInvite = this.isPendingInvite;
        p.teamRNID = this.teamRNID;
        p.teamJerseyNumber = this.teamJerseyNumber;
        p.positionID = this.positionID;
        p.positionName = this.positionName;
        p.positionShortName = this.positionShortName;
        p.homeTown = this.homeTown;
        p.birthPlace = this.birthPlace;
        p.shot = this.shot;
        p.catches = this.catches;
        p.nationalityID = this.nationalityID;
        p.height = this.height;
        p.weight = this.weight;
        p.schoolID = this.schoolID;
        p.collegeYearID = this.collegeYearID;
        p.collegeCommitmentID = this.collegeCommitmentID;
        p.collegeCommitmentYearID = this.collegeCommitmentYearID;
        p.collegeCommitmentIsVerbal = this.collegeCommitmentIsVerbal;
        p.grade = this.grade;
        p.gpa = this.gpa;
        p.sat = this.sat;
        p.act = this.act;
        p.email = this.email;
        p.cellphone = this.cellphone;
        p.birthdateNotConfirmed = this.birthdateNotConfirmed;
        p.agentID = this.agentID;
        p.agentFirstName = this.agentFirstName;
        p.agentLastName = this.agentLastName;
        p.streetAddress = this.streetAddress;
        p.city = this.city;
        p.provinceID = this.provinceID;
        p.countryID = this.countryID;
        p.postalCode = this.postalCode;
        p.addressPhone = this.addressPhone;
        p.birthdate = this.birthdate;
        p.highSchoolGradDate = this.highSchoolGradDate;
        p.futureTeamRNID = this.futureTeamRNID;
        p.futureTeamYearRNID = this.futureTeamYearRNID;

        return p;
    }
}